import {LoggerInterface} from './logger-interface';
import {LoggerManager} from './logger-manager';

export const Logger: LoggerInterface = {
  log(msg: string): void {
    LoggerManager.log(msg);
  },
  error(msg: string): void {
    LoggerManager.error(msg);
  },
  debug(msg: string): void {
    LoggerManager.debug(msg);
  },
  info(msg: string): void {
    LoggerManager.info(msg);
  },
  warn(msg: string): void {
    LoggerManager.warn(msg);
  },
};
